import { useCallback, useEffect, useState } from "react";
import { Link, Outlet } from "react-router-dom";
import { api } from "@/lib/api";
import { MenuSkeleton, readLang } from "@/components/menu/MenuStates";
import { makeT } from "@/i18n/strings";

const ORIGIN = window.location.origin;

export default function Preview() {
  const [data, setData] = useState(null);
  const [denied, setDenied] = useState(false);
  const load = useCallback(() => {
    api.get("/admin/preview")
      .then((r) => {
        setData(r.data);
        window.parent?.postMessage({ type: "wt-preview-ready" }, ORIGIN);
      })
      .catch(() => setDenied(true));
  }, []);

  useEffect(() => {
    load();
    const onMsg = (e) => {
      if (e.origin !== ORIGIN) return;
      if (e.data?.type === "wt-preview-settings") setData((d) => (d ? { ...d, settings: e.data.settings } : d));
      if (e.data?.type === "wt-preview-reload") load();
    };
    window.addEventListener("message", onMsg);
    return () => window.removeEventListener("message", onMsg);
  }, [load]);

  if (denied) {
    const t = makeT(readLang() || "en");
    return (
      <div className="grid min-h-screen place-items-center bg-[#121214] p-6 text-center text-white" data-testid="preview-denied">
        <div className="space-y-4">
          <p>{t("pub.previewAuth")}</p>
          <Link to="/admin/login" className="inline-block rounded-full bg-orange-500 px-5 py-2 font-semibold">{t("login.submit")}</Link>
        </div>
      </div>
    );
  }
  if (!data) return <MenuSkeleton />;
  return <Outlet context={{ data, mode: "preview", base: "/preview" }} />;
}
